import { Theme, WithStyles } from "@material-ui/core";
import { mockTheme, toMap } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import Grid from "@material-ui/core/Grid";
import { CompanyActions, CompanyState } from "../store/company";
import { SortDirection } from "@material-ui/core/TableCell";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import { AppDispatch, IStore } from "../store";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { Add as AddIcon, Delete, Edit, Map } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { ISubmitEvent, UiSchema } from 'react-jsonschema-form';
import Paper from '@material-ui/core/Paper';
import { AdminActions, IAdminStore } from "src/store/admin";
import { Company } from "src/api/model";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { BranchData } from "src/components/BranchSelector";
import { getApi } from "src/api/ApiProvider";
import EnhancedMap from "../components/enhancedMap";
import { withScriptjs } from "react-google-maps";
import { compose, withProps } from "recompose";
import { Configurations, active } from "../config";
import { NotificationType } from "src/store/notification/notification-actions";


const styles = (theme: Theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    routeSelector: {
        width: "100%",
        height: "100%"
    },
    buttons: {
        marginLeft: "auto",
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    }
});

const classesType = styles(mockTheme);

interface CompanyProps extends WithStyles<keyof typeof classesType> {
    adminActions: AdminActions;
    actions: CompanyActions;
    data: CompanyState;
    admin: IAdminStore;
    dispatch: AppDispatch;
}

interface CompanysState {
    abm: {
        name: string,
        photo: string,
        open: boolean;
        select?: { company: object };
        openEdit: boolean;
        pingUrl?: string;
        referenceId?: string;
        dbIP?: string;
        dbPort?: string;
        dbUser?: string;
        dbName?: string;
        dbPass?: string;
        dbType?: string;
    },
    branch: BranchData[];
    roles: any[];
    table: {
        data: any,
        sortBy: string,
        sortDirection: SortDirection
    }
    schema: JSONSchema6;
    schemaNew: JSONSchema6;
    // Estado para el mapa de ubicación de la sucursal
    branchLocation: {
        lat: number;
        lng: number;
        street1: string;
        street2: string;
    };
    // Estado para los datos del formulario
    formData: any;
}

const schema: JSONSchema6 = {
    definitions: {
        company: {
            type: 'object',
            required: ['name', 'photo'],
            properties: {
                name: { type: 'string', title: 'Nombre' },
                photo: { type: 'string', title: 'Foto' },
                pingUrl: { type: 'string', title: 'URL de ping' },
                referenceId: { type: 'string', title: 'Id de Referencia Ping' },
                dbIP: { type: 'string', title: 'IP de la base de datos' },
                dbPort: { type: 'string', title: 'Puerto de la base de datos' },
                dbUser: { type: 'string', title: 'Usuario de la base de datos' },
                dbName: { type: 'string', title: 'Nombre de la base de datos' },
                dbPass: { type: 'string', title: 'Contraseña de la base de datos' },
                dbType: { type: 'string', title: 'Tipo de base de datos' }
            }
        },
        pass: { type: 'string', title: 'Password', format: "password" },
    },

    title: "Editar informacion de compañia",
    type: "object",
    required: ["company"],
    properties: {
        company: { title: 'Empresa', "$ref": "#/definitions/company" },
        // admin: {title: "Administrador", "$ref": "#/definitions/admin"},
        // isNewAdmin: { title: "¿Agregar un nuevo administrador?", type: "boolean", default: false },
    },
};

const schemaNew: JSONSchema6 = {
    definitions: {
        company: {
            type: 'object',
            required: ['name', 'photo'],
            properties: {
                name: { type: 'string', title: 'Nombre' },
                photo: { type: 'string', title: 'Foto' },
                pingUrl: { type: 'string', title: 'URL de ping' },
                referenceId: { type: 'string', title: 'Id de Referencia Ping' },
                dbIP: { type: 'string', title: 'IP de la base de datos' },
                dbPort: { type: 'string', title: 'Puerto de la base de datos' },
                dbUser: { type: 'string', title: 'Usuario de la base de datos' },
                dbName: { type: 'string', title: 'Nombre de la base de datos' },
                dbPass: { type: 'string', title: 'Contraseña de la base de datos' },
                dbType: { type: 'string', title: 'Tipo de base de datos' }
            }
        },
        admin: {
            type: 'object',
            required: ['username', 'pass', 'email', 'branch', 'rol'],
            properties: {
                name: { type: 'string', title: 'Username' },
                email: { type: 'string', title: 'Email' },
                branch: {
                    type: 'number', title: 'Sucursal',
                    anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
                    default: 0
                },
                rol: {
                    type: 'string', title: 'Roles',
                    anyOf: [{ type: "string", enum: [0], title: "Cargando" }],
                    default: 0
                },
            }
        },
        branch: {
            type: 'object',
            required: ['name', 'street1', 'lat', 'lng'],
            properties: {
                name: { type: 'string', title: 'Nombre de la sucursal' },
                street1: { type: 'string', title: 'Dirección principal' },
                street2: { type: 'string', title: 'Dirección secundaria' },
                lat: { type: 'number', title: 'Latitud' },
                lng: { type: 'number', title: 'Longitud' },
                observation: { type: 'string', title: 'Observaciones' }
            }
        },
        pass: { type: 'string', title: 'Password', format: "password" },
    },
    title: "Agregar nueva compañia",
    type: "object",
    required: ["company", "admin", "pass", "branch"],
    properties: {
        company: { title: 'Empresa', "$ref": "#/definitions/company" },
        admin: { title: "Nuevo administrador", "$ref": "#/definitions/admin" },
        pass: { title: "Password", "$ref": "#/definitions/pass" },
        branch: { title: "Nueva sucursal", "$ref": "#/definitions/branch" },
    },
};

const uiSchema: UiSchema = {
    blendMode: {
        "ui:enumDisabled": [
            "multiply"
        ]
    },
    branch: {
        lat: {
            "ui:widget": "hidden"
        },
        lng: {
            "ui:widget": "hidden"
        },
        street1: {
            "ui:widget": "hidden"
        },
        street2: {
            "ui:widget": "hidden"
        }
        // name y observation se muestran normalmente
    }
};

const rolesData = [
    { id: 'ROLE_ADMIN', name: 'Super admin' },
    { id: 'ROLE_COMPANY_MANAGER', name: 'Administrador de Empresa' },
    { id: 'ROLE_BRANCH_MANAGER', name: 'Administrador de Sucursal' },

];

class CompanyPage extends React.Component<CompanyProps, CompanysState> {

    columnData = [

        { path: "id", disablePadding: true, label: "ID" },
        { path: "name", numeric: false, disablePadding: true, label: "Nombre" },
        {
            path: '', numeric: true, label: "Acciones", draw: (cd: ColumnDefinition, data: Company) => {
                return (
                    <div style={{ display: 'flex', gap: '4px', justifyContent: 'flex-end' }}>
                        <IconButton aria-label='Editar' title='Editar'
                            onClick={this.edit(data)}>
                            <Edit />
                        </IconButton>
                        <IconButton aria-label='Eliminar' title='Eliminar'
                            onClick={this.delete(data)}>
                            <Delete />
                        </IconButton>
                        <Link to={{
                            pathname: `/importMap`,
                            state: { company: data.id }
                        }}>
                            <IconButton aria-label='Importar mapa' title='Importar mapa'>
                                <Map />
                            </IconButton>
                        </Link>
                    </div>
                );
            }
        },
    ];

    constructor(props: CompanyProps) {
        super(props);

        this.state = {
            abm: {
                name: "",
                photo: "",
                open: false,
                openEdit: false,
                pingUrl: "",
                referenceId: "",
                dbIP: "",
                dbPort: "",
                dbUser: "",
                dbName: "",
                dbPass: "",
                dbType: "",

            },
            branch: [],
            roles: [],
            table: {
                data: [],
                sortBy: "name",
                sortDirection: "desc"
            },
            schemaNew: schemaNew,
            schema: schema,
            // Inicializar ubicación por defecto (Paraguay, mismo que sucursales)
            branchLocation: {
                lat: Configurations[active as keyof typeof Configurations].maps.startingLocation.lat,
                lng: Configurations[active as keyof typeof Configurations].maps.startingLocation.lng,
                street1: '',
                street2: ''
            },
            // Inicializar datos del formulario
            formData: {
                branch: {
                    lat: Configurations[active as keyof typeof Configurations].maps.startingLocation.lat,
                    lng: Configurations[active as keyof typeof Configurations].maps.startingLocation.lng,
                    street1: '',
                    street2: ''
                }
            }
        };
        getApi().branch().listAllBranchesAdmin().then((data: BranchData[]) => {
            this.setState({ branch: data });
            const newSchem: JSONSchema6 = JSON.parse(JSON.stringify(schemaNew));
            const adminDef = newSchem.definitions!.admin as JSONSchema6;
            const branch = adminDef.properties!.branch as JSONSchema6;
            console.log("branch", branch);
            branch.anyOf = data.map(d => ({
                type: "number",
                enum: [d.id],
                title: d.name + '-' + (d.company && d.company.name ? d.company.name : 'Cargando')
            }) as JSONSchema6);
            const roles = adminDef.properties!.rol as JSONSchema6;
            console.log("roles", roles);
            roles.anyOf = rolesData.map(d => ({
                type: "string",
                enum: [d.id],
                title: d.name ? d.name : 'Cargando'
            }) as JSONSchema6);
            this.setState({ schemaNew: newSchem });
        });


        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.updateCompanyPlace = this.updateCompanyPlace.bind(this);
        this.updateCompanyDir = this.updateCompanyDir.bind(this);
        this.companyLocationWidget = this.companyLocationWidget.bind(this);
        this.companyDirectionWidget = this.companyDirectionWidget.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
    }

    handleFormChange(data: any) {
        this.setState({
            formData: data.formData
        });
    }

    async handleSubmit(e: ISubmitEvent<any>) {
        try {
            // 1. Primero crear un admin temporal (sin branchObject)
            const tempAdminData = {
                name: e.formData.admin.name,
                email: e.formData.admin.email,
                pass: e.formData.pass,
                rol: e.formData.admin.rol
            };

            const api = getApi();
            const tempAdminResponse = await api.admin().add(tempAdminData);
            console.log('Admin temporal creado:', tempAdminResponse);

            // 2. Crear la empresa usando el admin temporal
            const companyData = {
                ...e.formData.company,
                adminId: tempAdminResponse.id,
                pingUrl: e.formData.company.pingUrl || "",
                referenceId: e.formData.company.referenceId || "",
                dbPort: e.formData.company.dbPort || "",
                dbUser: e.formData.company.dbUser || "",
                dbPass: e.formData.company.dbPass || "",
                dbIP: e.formData.company.dbIP || ""
            };
            const newCompanyResponse = await api.company().add(companyData);
            console.log('Empresa creada exitosamente:', newCompanyResponse);

            // 3. Crear la sucursal usando el ID de la empresa recién creada y las coordenadas del mapa
            if (newCompanyResponse && newCompanyResponse.id) {
                const branchData = {
                    companyId: newCompanyResponse.id,
                    lat: this.state.branchLocation.lat,
                    lng: this.state.branchLocation.lng,
                    maxDistance: 0,
                    name: e.formData.branch.name,
                    maxDistanceValidation: true,
                    number: e.formData.branch.number,
                    observation: e.formData.branch.observation,
                    street1: this.state.branchLocation.street1,
                    street2: this.state.branchLocation.street2
                };

                const newBranchResponse = await api.branch().add(branchData);
                console.log('Sucursal creada exitosamente:', newBranchResponse);

                // 4. Finalmente actualizar el admin con el objeto de sucursal
                const updatedAdminData = {
                    name: e.formData.admin.name, // Usar los datos del formulario
                    email: e.formData.admin.email, // Usar los datos del formulario
                    // pass: e.formData.pass,
                    branchObject: newBranchResponse, // Ahora agregar la sucursal al admin
                    rol: tempAdminResponse.rol
                };

                await api.admin().update(updatedAdminData, tempAdminResponse.id);
                console.log('Admin actualizado con sucursal exitosamente');

                console.log('Proceso completo: Admin, empresa, sucursal creados y vinculados exitosamente');
                console.log('ID de empresa:', newCompanyResponse.id);
                console.log('ID de sucursal:', newBranchResponse.id);
                console.log('ID de admin:', tempAdminResponse.id);
            } else {
                console.error('No se recibió una respuesta válida de la API al crear la empresa');
            }

            // Actualizar la lista de empresas
            this.props.actions.throwNoti('Empresa', 'Creación correcta', NotificationType.SUCCESS);
            this.props.actions.fetch();
            this.hideDialog();
        } catch (error) {
            console.error('Error en el proceso de creación:', error);
            // Aquí podrías mostrar un mensaje de error al usuario
        }
    }

    async handleSubmitEdit(e: ISubmitEvent<any>) {
        // console.log("handleSubmitEdit", e.formData); return
        const company = {
            name: e.formData.company.name || "",
            photo: e.formData.company.photo || "",
            pingUrl: e.formData.company.pingUrl || "",
            referenceId: e.formData.company.referenceId || "",
            dbIP: e.formData.company.dbIP || "",
            dbPort: e.formData.company.dbPort || "",
            dbUser: e.formData.company.dbUser || "",
            dbName: e.formData.company.dbName || "",
            dbPass: e.formData.company.dbPass || "",
            dbType: e.formData.company.dbType || "",
            adminId: undefined
        };

        // Actualizamos los datos de la compañia
        this.props.actions.update(company, e.formData.company.id);
        this.props.actions.fetch();
        this.hideDialog();
    }

    delete(data: Company) {

        return async (event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
            await this.props.actions.delete(data.id);
            // this.props.actions.fetch();
        }

    }

    edit(data: Company) {
        return async (event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
            await this.props.actions.fetchById(data.id);

            if (this.props.data.select.data) {
                this.setState({
                    abm: {
                        ...this.state.abm,
                        select: {
                            company: {
                                ...this.props.data.select.data,
                                pingUrl: this.props.data.select.data.pingUrl || "",
                                referenceId: this.props.data.select.data.referenceId || "",
                                dbIP: this.props.data.select.data.dbIP || "",
                                dbPort: this.props.data.select.data.dbPort || "",
                                dbUser: this.props.data.select.data.dbUser || "",
                                dbName: this.props.data.select.data.dbName || "",
                                dbPass: this.props.data.select.data.dbPass || "",
                                dbType: this.props.data.select.data.dbType || ""
                            },

                        },
                        openEdit: true
                    },
                })
            }
        }
    }


    sort(name: string) {
        return () => {
            this.setState({
                ...this.state,
                table: {
                    ...this.state.table,
                    sortBy: name,
                    sortDirection: "desc"
                }
            })

        }

    }

    componentDidMount() {
        this.props.actions.fetch();
    }

    hideDialog() {
        this.setState({
            abm: {
                ...this.state.abm,
                open: false,
                openEdit: false
            }
        });
    }

    showDialog() {
        this.setState({
            abm: {
                name: '',
                photo: '',
                pingUrl: '',
                referenceId: '',
                open: true,
                openEdit: false
            }
        });
    }

    updateCompanyPlace(place: google.maps.places.PlaceResult) {
        if (place.geometry && place.geometry.location) {
            // Obtener la dirección formateada
            const geoCoder = new google.maps.Geocoder();
            geoCoder.geocode({ location: place.geometry.location }, (results: any, status: any) => {
                if (status === "OK" && results[0]) {
                    const dir = results[0].formatted_address;
                    this.setState({
                        branchLocation: {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                            street1: dir.substring(0, dir.lastIndexOf(",", dir.indexOf(",") + 1)),
                            street2: dir.substring(dir.lastIndexOf(",", dir.indexOf(",") + 1) + 1)
                        }
                    });
                } else {
                    this.setState({
                        branchLocation: {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                            street1: "",
                            street2: ""
                        }
                    });
                }
            });
        }
    }

    updateCompanyDir(dir: string) {
        // Aquí puedes manejar la dirección de la sucursal si es necesario
        console.log('Dirección de sucursal:', dir);
    }

    companyLocationWidget(props: any) {
        return (
            <div>
                <EnhancedMap
                    zoom={12}
                    directions={undefined}
                    center={{ lat: this.state.branchLocation.lat, lng: this.state.branchLocation.lng }}
                    destiny={[{
                        location: { lat: this.state.branchLocation.lat, lng: this.state.branchLocation.lng },
                        order: ""
                    }]}
                    handleDragEnd={(marker: any, index?: number) => (e: google.maps.MouseEvent) => {
                        // Para drag end, actualizar ubicación directamente en el formulario
                        if (e.latLng) {
                            const geoCoder = new google.maps.Geocoder();
                            geoCoder.geocode({ location: e.latLng }, (results: any, status: any) => {
                                if (status === "OK" && results[0]) {
                                    const dir = results[0].formatted_address;
                                    const street1 = dir.substring(0, dir.lastIndexOf(",", dir.indexOf(",") + 1));
                                    const street2 = dir.substring(dir.lastIndexOf(",", dir.indexOf(",") + 1) + 1);

                                    // Actualizar tanto el estado local del mapa como el formulario - handleDragEnd
                                    this.setState({
                                        branchLocation: {
                                            lat: e.latLng.lat(),
                                            lng: e.latLng.lng(),
                                            street1: street1,
                                            street2: street2
                                        },
                                        formData: {
                                            ...this.state.formData,
                                            branch: {
                                                ...this.state.formData.branch,
                                                lat: e.latLng.lat(),
                                                lng: e.latLng.lng(),
                                                street1: street1,
                                                street2: street2
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    }}
                    handleOnClick={(e: google.maps.MouseEvent) => {
                        // Para click, actualizar ubicación directamente en el formulario
                        if (e.latLng) {
                            const geoCoder = new google.maps.Geocoder();
                            geoCoder.geocode({ location: e.latLng }, (results: any, status: any) => {
                                if (status === "OK" && results[0]) {
                                    const dir = results[0].formatted_address;
                                    const street1 = dir.substring(0, dir.lastIndexOf(",", dir.indexOf(",") + 1));
                                    const street2 = dir.substring(dir.lastIndexOf(",", dir.indexOf(",") + 1) + 1);

                                    // Actualizar tanto el estado local del mapa como el formulario - handleOnClick
                                    this.setState({
                                        branchLocation: {
                                            lat: e.latLng.lat(),
                                            lng: e.latLng.lng(),
                                            street1: street1,
                                            street2: street2
                                        },
                                        formData: {
                                            ...this.state.formData,
                                            branch: {
                                                ...this.state.formData.branch,
                                                lat: e.latLng.lat(),
                                                lng: e.latLng.lng(),
                                                street1: street1,
                                                street2: street2
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    }}
                />
            </div>
        );
    }

    companyDirectionWidget(props: any) {
        return (
            <div style={{ color: '#666', fontSize: '0.875rem' }}>
                Selecciona la ubicación de la sucursal en el mapa arriba
            </div>
        );
    }

    render() {
        return (
            <Grid container spacing={24}>
                <Grid item sm={12} md={12}>
                    <AsyncTable
                        columnDefinition={this.columnData}
                        showFiltro={true}
                        title="Empresas"
                        data={this.props.data.data}
                        defaultOrder={{
                            name: "name",
                            direction: "desc"
                        }}
                        headerButtons={(
                            <Tooltip title="Agregar">
                                <IconButton aria-label="Agregar" onClick={this.showDialog}>
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        )} />

                </Grid>
                {<Dialog open={this.state.abm.open}
                    maxWidth="md"
                    fullWidth={true}>
                    <Paper className={this.props.classes.abm}>
                        <h6 style={{ marginBottom: 16 }}>
                            Selecciona la ubicación de la sucursal en el mapa (mismo origen que otras sucursales)
                        </h6>
                        <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: 16 }}>
                            Lat: {this.state.branchLocation.lat.toFixed(6)}, Lng: {this.state.branchLocation.lng.toFixed(6)}
                        </p>
                        {this.companyLocationWidget({})}
                        <EnhancedSchemaForm
                            schema={this.state.schemaNew}
                            onSubmit={this.handleSubmit}
                            onChange={this.handleFormChange}
                            formData={this.state.formData}
                            uiSchema={uiSchema}>
                            <Grid container justify="space-around">
                                <Grid item>
                                    <Button variant="contained" onClick={this.hideDialog}>
                                        Cancelar
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" type="submit">
                                        Aceptar
                                    </Button>
                                </Grid>
                            </Grid>
                        </EnhancedSchemaForm>
                    </Paper>
                </Dialog>}
                <Dialog open={this.state.abm.openEdit} maxWidth="md" fullWidth={true}>
                    <Paper className={this.props.classes.abm}>
                        <EnhancedSchemaForm
                            schema={this.state.schema}
                            onSubmit={this.handleSubmitEdit}
                            formData={{
                                ...this.state.abm.select,
                            }}
                            uiSchema={uiSchema}>
                            <Grid container justify="space-around">
                                <Grid item>
                                    <Button variant="contained" onClick={this.hideDialog}>
                                        Cancelar
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" type="submit">
                                        Aceptar
                                    </Button>
                                </Grid>
                            </Grid>
                        </EnhancedSchemaForm>
                    </Paper>
                </Dialog>
            </Grid>
        )
    }
}

const mapStateToProps = (state: IStore, ownProps: any) => ({
    ...ownProps,
    data: state.company,
    admin: state.admin
});

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
        dispatch,
        actions: bindActionCreators(toMap(CompanyActions), dispatch),
        adminActions: bindActionCreators(toMap(AdminActions), dispatch),
    }
};

const styled = withStyles(styles as any)(CompanyPage);
const connected = connect(mapStateToProps, mapDispatchToProps)(styled);

export default compose<any, Partial<CompanyProps>>(
    withProps((props: Partial<CompanyProps>) => ({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${Configurations[active as keyof typeof Configurations].maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />
    })),
    withScriptjs
)(connected) as ComponentClass<Partial<CompanyProps>>;



// WEBPACK FOOTER //
// ./src/pages/CompanyPage.tsx